export function extractPeerIdFromMultiaddr(multiaddr: string): string | null {
  const parts = multiaddr.split('/p2p/');
  return parts.length > 1 && parts[1].length > 0 ? parts[1] : null;
}
